import { render, staticRenderFns } from "./MaterialsTable.vue?vue&type=template&id=166ec14b&scoped=true&"
import script from "./MaterialsTable.vue?vue&type=script&lang=js&"
export * from "./MaterialsTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsTable.vue?vue&type=style&index=0&id=166ec14b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ec14b",
  null
  
)

export default component.exports